import { render } from "./PaywallDynamic.vue?vue&type=template&id=66af5322&scoped=true"
import script from "./PaywallDynamic.vue?vue&type=script&lang=js"
export * from "./PaywallDynamic.vue?vue&type=script&lang=js"

import "./PaywallDynamic.vue?vue&type=style&index=0&id=66af5322&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66af5322"]])

export default __exports__